export const COMPLETE_LOCALE_PACKS={};
